module.exports = "/assets/data/04168d86f9b8e757542ca1e1f3baa484-NR13.data.json";